import { render, staticRenderFns } from "./formgrouptextphone.vue?vue&type=template&id=759f5586&"
import script from "./formgrouptextphone.vue?vue&type=script&lang=js&"
export * from "./formgrouptextphone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports